import { useState } from "react";

type Props = {
  value: number;
  onChange?: (v: number) => void;
  readOnly?: boolean;
  size?: "sm" | "md" | "lg";
};

const sizeClass: Record<NonNullable<Props["size"]>, string> = {
  sm: "text-base",
  md: "text-xl",
  lg: "text-2xl",
};

export function StarRating({ value, onChange, readOnly, size = "md" }: Props) {
  const [hover, setHover] = useState<number | null>(null);
  const display = hover ?? value;
  return (
    <div className={`inline-flex gap-0.5 ${sizeClass[size]}`} aria-label={`${value} od 5 zvjezdica`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          disabled={readOnly}
          aria-label={`${i} zvjezdica`}
          onMouseEnter={() => !readOnly && setHover(i)}
          onMouseLeave={() => !readOnly && setHover(null)}
          onClick={() => !readOnly && onChange?.(i)}
          className={`${readOnly ? "cursor-default" : "cursor-pointer"} ${i <= display ? "text-yellow-500" : "text-neutral-300"} leading-none`}
        >
          ★
        </button>
      ))}
    </div>
  );
}
